import { get, post } from '../lib/apiClient';

/** GET /public/orgs/{orgSlug} - no auth */
export const getOrgProfile = orgSlug =>
  get(`/public/orgs/${encodeURIComponent(orgSlug)}`, { auth: false });

/** GET /public/orgs/{orgSlug}/events - no auth */
export const listOrgEvents = (orgSlug, query) =>
  get(`/public/orgs/${encodeURIComponent(orgSlug)}/events`, { auth: false, query });

/** GET /public/orgs/{orgSlug}/events/{eventId} - no auth */
export const getOrgEventDetail = (orgSlug, eventId) =>
  get(`/public/orgs/${encodeURIComponent(orgSlug)}/events/${encodeURIComponent(eventId)}`, {
    auth: false,
  });

/** GET /public/orgs/{orgSlug}/videos - no auth */
export const listOrgVideos = (orgSlug, query) =>
  get(`/public/orgs/${encodeURIComponent(orgSlug)}/videos`, { auth: false, query });

/**
 * POST /public/orgs/{orgSlug}/videos/{videoId}/watch - no auth. A preview for
 * a visitor or non-member (docs/Decisions.md D65 item 1), counted per
 * `visitorId` (frontend/src/lib/visitorId.js).
 */
export const watchOrgVideo = (orgSlug, videoId, visitorId) =>
  post(
    `/public/orgs/${encodeURIComponent(orgSlug)}/videos/${encodeURIComponent(videoId)}/watch`,
    { visitorId },
    { auth: false }
  );
